import {
  AutoForceDeepLinkHook,
  IOneLinkHook,
  OneLink,
  OneLinkFactory,
  WebDeepLinkHook,
} from '@lemon8/web-app-shared/active';
import { $RootTraffic, $SearchParams, $UserAgent } from '@lemon8/web-app-shared/atom';
import { atom } from 'jotai';
import { $ShareInfo } from '~/models/share-info';

interface OneLinkProps {
  campaignId: string;
  schema: string;
  extraDeepLinkValueData?: Record<string, any>;
  ampExtra?: Record<string, any>;
}

const $DefaultOneLinkFactory = atom<OneLinkFactory>((get) => {
  const { userAgent } = get($UserAgent);

  const oneLinkFactoryHooks: IOneLinkHook[] = [
    new WebDeepLinkHook({ userAgent }),
    new AutoForceDeepLinkHook({ userAgent }),
  ];

  return new OneLinkFactory({
    hooks: oneLinkFactoryHooks,
  });
});

export const createActivitiesOnelink = (props: OneLinkProps): OneLink => {
  const { campaignId, extraDeepLinkValueData = {}, schema, ampExtra = {} } = props;

  const oneLinkFactory = window.store.get($DefaultOneLinkFactory);
  const oneLink = oneLinkFactory.create({ schema });

  const { trafficPid: trafficType } = window.store.get($RootTraffic);
  const { sharePlatform, sharePageName } = window.store.get($ShareInfo);

  const schemaWithParams = new URL(schema);
  schemaWithParams.searchParams.set('pid', campaignId);
  schemaWithParams.searchParams.set('share_platform', sharePlatform);
  schemaWithParams.searchParams.set('share_page_name', sharePageName);

  const urlSearchParams = window.store.get($SearchParams);
  const userAgent = window.store.get($UserAgent);
  const isTest = urlSearchParams.get('is_test') === '1';

  if (isTest) {
    if (userAgent.isiOS) {
      oneLink.params.pid = 'ios_testing';
    } else {
      oneLink.params.pid = 'android_testing';
    }
  } else {
    oneLink.params.pid = campaignId;
  }

  oneLink.params.deepLinkValue = { type: 'campaign', id: campaignId, ...extraDeepLinkValueData } as any;
  oneLink.params.deepLink = schemaWithParams.toString();
  oneLink.params.ampExtra.setExtras({
    traffic_type: trafficType,
    enter_page_id: campaignId,
    enter_page_type: 'activity',
    share_platform: sharePlatform,
    share_page_name: sharePageName,
    ...ampExtra,
    ...extraDeepLinkValueData,
  });

  return oneLink;
};
